import { render, staticRenderFns } from "./questionContentLayer.vue?vue&type=template&id=5bc33cb1&scoped=true&"
import script from "./questionContentLayer.vue?vue&type=script&lang=js&"
export * from "./questionContentLayer.vue?vue&type=script&lang=js&"
import style0 from "./questionContentLayer.vue?vue&type=style&index=0&id=5bc33cb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc33cb1",
  null
  
)

export default component.exports